// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { Dimension, DIMENSION_TYPES } from "~shared-pathways";

export const dimensionsByMetricType = {
  // PRISON
  prison_population_projection_time_series: [
    DIMENSION_TYPES.SEX,
    DIMENSION_TYPES.LEGAL_STATUS,
  ],
  // SUPERVISION
  supervision_population_projection_time_series: [DIMENSION_TYPES.SEX],
  // SUPERVISION TO PRISON
  supervision_to_prison_population_snapshot_by_officer: [
    DIMENSION_TYPES.SEX,
    DIMENSION_TYPES.SUPERVISION_TYPE,
    DIMENSION_TYPES.DISTRICT,
    DIMENSION_TYPES.AGE_GROUP,
    DIMENSION_TYPES.SUPERVISION_LEVEL,
    DIMENSION_TYPES.RACE,
    DIMENSION_TYPES.OFFICER_NAME,
  ],
  supervision_to_prison_population_snapshot_by_dimension: [
    DIMENSION_TYPES.SEX,
    DIMENSION_TYPES.SUPERVISION_TYPE,
    DIMENSION_TYPES.DISTRICT,
    DIMENSION_TYPES.AGE_GROUP,
    DIMENSION_TYPES.MOST_SEVERE_VIOLATION,
    DIMENSION_TYPES.NUMBER_OF_VIOLATIONS,
    DIMENSION_TYPES.LENGTH_OF_STAY,
    DIMENSION_TYPES.SUPERVISION_LEVEL,
    DIMENSION_TYPES.RACE,
  ],
} as Record<string, Dimension[]>;
